"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimLineSprite = void 0;
const pixi_js_1 = require("pixi.js");
const inversify_1 = require("inversify");
const SymbolClasses_1 = require("../../Utils/SymbolClasses");
let SimLineSprite = class SimLineSprite extends pixi_js_1.Sprite {
    constructor(resources, helper) {
        var _a;
        super((_a = resources.game.textures) === null || _a === void 0 ? void 0 : _a.simultaneous_line);
        this.helper = helper;
        this.shouldRemove = false;
        this.anchor.set(0.5);
        this.visible = false;
    }
    applyInfo(sim) {
        this.sim = sim;
        this.shouldRemove = false;
        this.visible = true;
    }
    update(musicTime) {
        if (!this.visible || this.shouldRemove || !this.sim)
            return;
        if (this.sim.left.judge || this.sim.right.judge || musicTime > this.sim.left.time + 1) {
            this.shouldRemove = true;
            this.visible = false;
            this.zIndex = 0;
            return;
        }
        const lp = this.helper.calc(this.sim.left, musicTime);
        const rp = this.helper.calc(this.sim.right, musicTime);
        this.height = lp.scale * this.texture.height * this.helper.noteScale;
        this.width = lp.x - rp.x;
        this.x = (lp.x + rp.x) / 2;
        this.y = lp.y;
        this.zIndex = lp.scale;
    }
};
SimLineSprite = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [SymbolClasses_1.Resources, SymbolClasses_1.NoteHelper])
], SimLineSprite);
exports.SimLineSprite = SimLineSprite;
//# sourceMappingURL=SimLineSprite.js.map